import type { AnalysesPlaceItem } from 'src/components/pages/[town-translit]/diagnostika/analiz/api/apiAnalysesDistricts.types'

export const DEFAULT_ANALYSES_PLACE: AnalysesPlaceItem = {
  id: 0,
  name: 'Все районы',
  translit: 'default-item',
}
